import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { toastLifetimeMs } from '@assist/design-tokens';
import { StatusIcon } from './StatusIcon.js';
export function Toast({ kind, signalWord, title, children, onDismiss, closeLabel = '×' }) {
    const [paused, setPaused] = useState(false);
    const remaining = useRef(toastLifetimeMs(kind));
    useEffect(() => {
        if (paused || remaining.current === null)
            return undefined;
        const started = Date.now();
        const timer = window.setTimeout(onDismiss, remaining.current);
        return () => {
            window.clearTimeout(timer);
            if (remaining.current !== null) {
                remaining.current = Math.max(0, remaining.current - (Date.now() - started));
            }
        };
    }, [paused, onDismiss]);
    return (_jsxs("div", { className: `assist-toast assist-toast--${kind}`, role: kind === 'danger' ? 'alert' : 'status', "aria-live": kind === 'danger' ? 'assertive' : 'polite', onMouseEnter: () => setPaused(true), onMouseLeave: () => setPaused(false), onFocus: () => setPaused(true), onBlur: () => setPaused(false), children: [_jsx(StatusIcon, { kind: kind, size: 18 }), _jsxs("div", { className: "assist-toast__body", children: [_jsxs("p", { className: "assist-toast__title", children: [_jsx("span", { className: "assist-toast__signal", children: signalWord }), " ", title] }), children ? _jsx("div", { className: "assist-toast__text", children: children }) : null] }), _jsx("button", { type: "button", className: "assist-toast__close", onClick: onDismiss, "aria-label": closeLabel, children: "\u00D7" })] }));
}
//# sourceMappingURL=Toast.js.map